import { createFileRoute } from "@tanstack/react-router"

import ProductsReport from "~/components/prototype/allocation-planning/reports/ProductsReport"

export const Route = createFileRoute("/_auth/allocation/_layout/reports/products")({
  component: ProductsReport,
})
